import { render, staticRenderFns } from "./10e_doc.vue?vue&type=template&id=15d6ba57&scoped=true"
import script from "./10e_doc.vue?vue&type=script&lang=js"
export * from "./10e_doc.vue?vue&type=script&lang=js"
import style0 from "./10e_doc.vue?vue&type=style&index=0&id=15d6ba57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d6ba57",
  null
  
)

export default component.exports